export default "__VITE_ASSET__dawFfyQb__"